import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";

// reducer & middlewares
import { applyMiddleware, compose, createStore } from "redux";
import { Provider } from "react-redux";
import { Router } from "react-router";
import { IntlProvider } from "react-intl";
import moment from "moment";
import {
  setResource,
  LINE_ITEM_RESOURCE,
  SUB_LINE_ITEM_RESOURCE,
  UNIT_RESOURCE,
  CATALOG_RESOURCE,
  PRODUCT_LINE_RESOURCE
} from "shared/actions/actionLocator";
import { LineItemResource } from "shared/actions/roomBookActions";
import { combinedReducers } from "../marketing_portal/reducers/setup";

// router
import routes from "../marketing_portal/routes/routes";
import { browserHistory } from "../shared/routes/browserHistory";

// style
import "shared/styles/reset.scss";
import "semantic-ui-css/semantic.min.css";

// i18n
import { translations } from "../i18n/translations";
// momentjs

// Polyfills
import "core-js/stable";
import "regenerator-runtime/runtime";

// get state settings from local storage
import localStorage from "../shared/helpers/localStorage";

import {
  SubLineItemResource,
  ProductLineResource
} from "../marketing_portal/actions/roomBookActions";
import { UnitsResource } from "../marketing_portal/actions/unitActions";
import CatalogsResource from "../marketing_portal/actions/catalogsActions";

if (process.env.RAVEN_DSN && process.env.RAVEN_DSN !== "") {
  Sentry.init({ dsn: process.env.RAVEN_DSN });
}

const locale = "de";
const localizedI18nMessages = translations[locale];
moment.locale(locale);

let filter = {};
try {
  filter = JSON.parse(localStorage.get("filter"));
} catch (e) {
  // continue regardless of error
}

class App extends React.Component {
  static propTypes = {};

  constructor(props) {
    super(props);

    const { logoPath, account, branding } = window.initialProps;

    this.initialState = {
      ...this.props,
      filter,
      locale,
      logoPath,
      branding,
      i18n: localizedI18nMessages,
      pageContent: null,
      account: account || null,
      message: null,
      isLoading: false,
      dialog: null
    };

    const middlewares = [];
    let composeEnhancers = compose;
    if (
      process.env.DISABLE_REDUX_STATE_LOGGING !== "true" &&
      process.env.RAILS_ENV === "development"
    ) {
      // logger may not even initialize to prevent logging
      // eslint-disable-next-line global-require
      const logger = require("../shared/middlewares/logger").default;
      middlewares.push(logger);
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
    }

    this.store = createStore(
      combinedReducers,
      this.initialState,
      composeEnhancers(applyMiddleware(...middlewares))
    );

    setResource(LINE_ITEM_RESOURCE, LineItemResource);
    setResource(SUB_LINE_ITEM_RESOURCE, SubLineItemResource);
    setResource(PRODUCT_LINE_RESOURCE, ProductLineResource);
    setResource(UNIT_RESOURCE, UnitsResource);
    setResource(CATALOG_RESOURCE, CatalogsResource);
  }

  render() {
    return (
      <IntlProvider
        locale={locale}
        key={locale}
        messages={localizedI18nMessages}
      >
        <Provider store={this.store}>
          <Router history={browserHistory}>
            {routes(this.store.dispatch)}
          </Router>
        </Provider>
      </IntlProvider>
    );
  }
}

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <App />,
    document.body.appendChild(document.createElement("div"))
  );
});
